import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/utils/cn";
import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";
export function Label({ className, ...props }) {
    return (_jsx(LabelPrimitive.Root, { "data-slot": "label", className: cn("flex select-none items-center gap-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50", className), ...props }));
}
